export const MATCHTABLECOLUMNS = "100px 50px 100px 1fr 100px 40px 40px";
